import { ExclamationCircleFilled, InfoCircleFilled } from '@ant-design/icons'
import { Alert } from 'antd'
import { type CSSProperties } from 'react'
import { type FamilyMemberType } from 'types/services/Family'
import { type Recommendation } from 'types/services/Recommedation'
import { isEmptyObject } from 'utils/utils'
import { formatMemberDesc } from 'utils/familyUtils'

import iconChecked from 'assets/icons/check-preenchido.svg'

import './styles.scss'

interface RecommendationInfoCardProps {
  question: string
  answer: string
  isAlert: boolean
  justificationText: string
  memberAndFamilyHeadInfo: FamilyMemberType[]
  infosRecommedation: Recommendation
}

function RecommendationInfoCard({
  question,
  answer,
  isAlert,
  justificationText,
  memberAndFamilyHeadInfo,
  infosRecommedation,
}: RecommendationInfoCardProps) {
  const alert = isAlert ? 'alert' : ''

  const styleSituationIcon: CSSProperties = isAlert
    ? { fontSize: '30px', color: '#F67D7D' }
    : { fontSize: '30px', color: '#80C470' }

  const styleStrongNameMember = { marginBottom: '.7rem', marginTop: '1rem' }

  return (
    <div className="containerRecommendationInfocard">
      <div className={`containerRecommendationInfocard-situation ${alert}`}>
        <div className="containerRecommendationInfocard-situation__header">
          <div className="containerRecommendationInfocard-situation__header__title">
            <strong>{question}</strong>
            <span>{answer}</span>
          </div>
          {isAlert ? (
            <ExclamationCircleFilled style={styleSituationIcon} />
          ) : (
            <img src={iconChecked} alt="ok" height="32px" />
          )}
        </div>
        {isAlert && (
          <Alert
            description={justificationText}
            type="info"
            icon={<InfoCircleFilled />}
            showIcon
          />
        )}
      </div>

      {infosRecommedation.isSent === true && (
        <div className="containerRecommendationInfocard-recommendation">
          <strong>Recomendação</strong>
          <span>{infosRecommedation.recommendationText}</span>
        </div>
      )}

      <div className="containerRecommendationInfocard-member">
        {memberAndFamilyHeadInfo[0].name === memberAndFamilyHeadInfo[1].name ? (
          <>
            <strong style={styleStrongNameMember}>
              Membro da familia e pessoa responsável pela unidade familiar:
            </strong>
            <span>{memberAndFamilyHeadInfo[0].name}</span>
            <span>
              <i>{formatMemberDesc(memberAndFamilyHeadInfo[0])}</i>
            </span>
          </>
        ) : (
          <>
            {!isEmptyObject(memberAndFamilyHeadInfo[0]) && (
              <>
                <strong style={styleStrongNameMember}>
                  Membro da familia:
                </strong>
                <span>{memberAndFamilyHeadInfo[0].name}</span>
                <span>
                  <i>{formatMemberDesc(memberAndFamilyHeadInfo[0])}</i>
                </span>
              </>
            )}
            <>
              <strong style={styleStrongNameMember}>
                Pessoa Responsável pela unidade familiar:
              </strong>
              <span>{memberAndFamilyHeadInfo[1].name}</span>
              <span>
                <i>{formatMemberDesc(memberAndFamilyHeadInfo[1])}</i>
              </span>
            </>
          </>
        )}
      </div>
      {infosRecommedation.isSent === true && (
        <div className="containerRecommendationInfocard-aditionalInfos">
          <hr />
          <strong>
            Agente: <br />
            {infosRecommedation?.responsibleAgent ?? `Não informado`}
          </strong>
          <span>
            {' '}
            Instituição: {infosRecommedation?.institutionRecommender}
          </span>
          <span>Telefone: {infosRecommedation?.phoneRecommender}</span>
          <span>E-mail: {infosRecommedation?.emailRecommender}</span>

          <hr style={{ marginTop: '1rem' }} />
          <strong>
            {' '}
            Autor: <br />
            {infosRecommedation?.createdBy}
          </strong>
          <span>
            {' '}
            Instituição: {infosRecommedation?.institutionRecommender}
          </span>
          <span>
            Criado em:{' '}
            {infosRecommedation.createdAt != null &&
              new Date(infosRecommedation.createdAt).toLocaleDateString()}
          </span>
        </div>
      )}
    </div>
  )
}

export default RecommendationInfoCard
